/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../widgets/livewidget/nls/StringResources'
], function(APIFactory, PropertiesProviderAPI, StringResources) {

	const PROP_ID_EXPANDCOLLAPSE = 'expandCollapse';

	class ExpandCollapsePropertyProvider {

		constructor(options) {
			this.content = options.content;

			this.visualization = options.features.Visualization;

			// register self as a 'Properties' provider
			options.features.Properties.registerProvider(this.getAPI());
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this.content = null;
		}

		getPropertyLayoutList() {
			return [];
		}

		getPropertyList() {
			const propertyList = [];
			if (this._isReady() && this._isSupported()) {
				propertyList.push({
					id: PROP_ID_EXPANDCOLLAPSE,
					editor: {
						'sectionId': 'visualization.chart',
						uiControl: {
							type: 'ToggleButton',
							defaultValue: true,
							label: StringResources.get(PROP_ID_EXPANDCOLLAPSE),
							onChange: (propertyName, propertyValue) => {
								this.content.setPropertyValue(propertyName, propertyValue);
							}
						}
					},
					onPropertyChange: {
						refresh: {
							data: true
						}
					},
					defaultValue: true
				});
			}
			return propertyList;
		}

		reset() { }

		_getModuleState() {
			const dataSource = this.visualization.getDataSource();
			return dataSource && dataSource.getState();
		}

		_isReady() {
			return this._getModuleState() === 'ready';
		}

		_isSupported() {
			return this._isSupportedVisType(this.visualization) && this._isOlap(this.visualization);
		}

		_isSupportedVisType(visualization) {
			return visualization.getType() === 'Crosstab';
		}

		_isOlap(visualization) {
			const mappedSlotList = visualization.getSlots().getMappedSlotList();
			const dataItemList = mappedSlotList && mappedSlotList[0] && mappedSlotList[0].getDataItemList();
			const metadataColumn = dataItemList && dataItemList[0] && dataItemList[0].getMetadataColumn();
			return metadataColumn && metadataColumn.isOlapColumn() || false;
		}
	}

	return ExpandCollapsePropertyProvider;
});
